import type React from 'react';
import DeadLineModal from '../DeadlineModal/DeadLineModal';

export interface RegularPriceProps {
  isSoldOut: boolean;
  price: string;
  productId: number;
  shippingCostsText: string;
  siteUrl: string;
}

export const RegularPrice: React.FC<RegularPriceProps> = ({
  isSoldOut,
  price,
  productId,
  shippingCostsText,
  siteUrl,
}) => (
  <div className="article-price">
    <span className="article-price__total">{price}</span>
    {!isSoldOut && (
      <DeadLineModal
        productId={productId}
        shippingCostsText={shippingCostsText}
        siteUrl={siteUrl}
      />
    )}
  </div>
);
